/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import { useDispatch } from "react-redux";
import { ActionCreators } from "actions";

import { Text } from "UpduoLibrary";
import {
  colorWithLuminance,
  skaleTextBlue,
  skaleBlue,
} from "config/UpduoColors";
import * as UpduoAnalytics from "config/UpduoAnalytics";

export default function NavigationBarItem({
  color = skaleTextBlue,
  activeColor = skaleBlue,
  fontSize = 14,
  marginLeft = 15,
  marginRight = 15,
  padding = "29px 0px",
  to,
  itemName,
  exact = false,
}) {
  const dispatch = useDispatch();

  const [isHovering, setIsHovering] = useState(false);

  const linkStyle = {
    fontSize: fontSize,
    marginLeft: marginLeft,
    marginRight: marginRight,
    padding: padding,
    letterSpacing: 0.5,
    fontFamily: "ObjectSans-Medium",
    fontWeight: "bold" as const,
    color: isHovering ? colorWithLuminance(activeColor, -0.2) : color,
  };
  if (to) {
    return (
      <NavLink
        to={to}
        exact={exact}
        activeStyle={{
          color: activeColor,
          borderTop: `3px solid transparent`,
          borderBottom: `3px solid ${skaleBlue}`,
        }}
        style={Object.assign({}, linkStyle, { textDecoration: "none" })}
        onMouseEnter={() => {
          setIsHovering(true);
        }}
        onMouseLeave={() => {
          setIsHovering(false);
        }}
        onClick={() => {
          dispatch(ActionCreators.setDisplayedSummitView("Summit"));
          UpduoAnalytics.logEvent("user-app-navbar-link", {
            name: itemName,
            to: to,
          });
        }}
      >
        {itemName}
      </NavLink>
    );
  } else {
    return <Text style={linkStyle}>{itemName}</Text>;
  }
}
